var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReportsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 21,
    viewBox: "0 0 17 21",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.43037 0.5C3.83865 0.5 3.35895 0.979694 3.35895 1.57143C3.35895 2.16316 3.83865 2.64286 4.43037 2.64286H13.7161C13.9134 2.64286 14.0732 2.80276 14.0732 3V16.5714C14.0732 17.1631 14.5529 17.6429 15.1447 17.6429C15.7364 17.6429 16.2161 17.1631 16.2161 16.5714V3C16.2161 1.61929 15.0968 0.5 13.7161 0.5H4.43037ZM0.144531 6.21429C0.144531 5.03081 1.10392 4.07143 2.28739 4.07143H10.1445C11.328 4.07143 12.2874 5.03081 12.2874 6.21429V18.3571C12.2874 19.5406 11.328 20.5 10.1445 20.5H2.28739C1.10392 20.5 0.144531 19.5406 0.144531 18.3571V6.21429ZM2.46552 7.64286C2.46552 7.14974 2.86527 6.75 3.35837 6.75H9.07266C9.56577 6.75 9.96552 7.14974 9.96552 7.64286C9.96552 8.13597 9.56577 8.53571 9.07266 8.53571H3.35837C2.86527 8.53571 2.46552 8.13597 2.46552 7.64286ZM3.35907 10.3214C2.86596 10.3214 2.46622 10.7212 2.46622 11.2143C2.46622 11.7074 2.86596 12.1071 3.35907 12.1071H9.07336C9.56647 12.1071 9.96622 11.7074 9.96622 11.2143C9.96622 10.7212 9.56647 10.3214 9.07336 10.3214H3.35907ZM2.46513 14.7857C2.46513 14.2926 2.86489 13.8929 3.35799 13.8929H6.21513C6.70825 13.8929 7.10799 14.2926 7.10799 14.7857C7.10799 15.2789 6.70825 15.6786 6.21513 15.6786H3.35799C2.86489 15.6786 2.46513 15.2789 2.46513 14.7857Z",
    fill: "#CBCED4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportsIcon);
export default __webpack_public_path__ + "static/media/reportsIcon.555d26f6ac4660b2490b1e7f6b922157.svg";
export { ForwardRef as ReactComponent };